import axios from "../../../util/axios";
import {PARTNER_TYPE} from "@/views/h5/crm/crmDictionary";

const PREFIX_URI = "/basedata/partner/opportunity";

/**
 * 客户跟进记录接口
 *
 * 跟进记录与商机跟进共用同一张表 crm_partner_follow，也没有独立的 controller，
 * 所以走的还是商机那个 controller 的接口 —— 按对象类型筛出客户跟进即可。
 */
export default {
    /** 查询客户跟进记录列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryFollowList`, data: {...data, partnerType: PARTNER_TYPE.CUSTOMER}}),
    /** 查询某个客户的跟进动态 */
    queryByCustomer: (partnerId) => axios.get({url: `${PREFIX_URI}/queryFollowByPartner`, data: {partnerId}}),
    /** 保存跟进记录 */
    saveFollow: (data) => axios.post({url: `${PREFIX_URI}/saveFollow`, data}),
}
